import React from "react";

// Discreet botanical line-art decorations (SVG, warm brown/gold strokes)

export const LeafBranch = ({ className = "", flip = false }) => (
  <svg
    className={className}
    style={flip ? { transform: "scaleX(-1)" } : undefined}
    viewBox="0 0 120 160"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path d="M60 155 C60 110 55 70 40 30" stroke="#C5A059" strokeWidth="1.4" strokeLinecap="round" />
    <g stroke="#C5A059" strokeWidth="1.2" fill="none">
      <path d="M55 120 C35 118 22 128 18 142 C38 144 52 136 55 120Z" />
      <path d="M53 96 C74 92 88 100 93 114 C73 118 58 110 53 96Z" />
      <path d="M50 72 C31 68 19 76 15 90 C34 93 47 86 50 72Z" />
      <path d="M46 50 C66 45 79 52 84 65 C65 69 51 63 46 50Z" />
      <path d="M42 32 C25 28 14 35 11 47 C28 50 39 44 42 32Z" />
    </g>
  </svg>
);

export const SmallSprig = ({ className = "" }) => (
  <svg className={className} viewBox="0 0 64 40" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
    <path d="M2 20 H62" stroke="#C5A059" strokeWidth="1" strokeLinecap="round" />
    <circle cx="32" cy="20" r="2.4" fill="#C5A059" />
    <g stroke="#C5A059" strokeWidth="1" fill="none">
      <path d="M14 20 C10 12 4 9 0 9 C2 15 7 19 14 20Z" />
      <path d="M50 20 C54 12 60 9 64 9 C62 15 57 19 50 20Z" />
      <path d="M22 20 C20 14 16 11 12 11 C13 16 17 19 22 20Z" />
      <path d="M42 20 C44 14 48 11 52 11 C51 16 47 19 42 20Z" />
    </g>
  </svg>
);
